// extracted by css-extract-rspack-plugin
module.exports =  {"toggleButtonContainer":"Admin__toggleButtonContainer___FMTPU"};